<template>
  <div class="page-wrapper narrow-container">
    <div v-if="isMobile==false" class="container logo-container">
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif" width="100%"/>
        </div>
      </div>
    </div>
    <div class="container section-container">
      <h2>{{msg}}</h2>
    </div>
    <div class="container">
      <div class="form-group row">
        <div class="col-12">
          <input type="text" id="userName" v-model="userName" class="form-control text-center" placeholder="User Name"
                 required autocapitalize="none" @keyup.enter="login"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <input type="password" id="password" v-model="password" class="form-control text-center"
                 placeholder="Password" required @keyup.enter="login"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <div class="form-item">
            <input type="checkbox" v-model="autoLogin" class="form-check-input" id="autoLogin" ref="autoLoginChecked">
            <label class="form-check-label" for="autoLogin">로그인 상태유지</label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <button type="button" class="form-control btn btn-primary admin-login-btn" v-on:click="login(false)">로그인
          </button>
        </div>
        <div class="col-6" v-if="false">
          <button type="button" class="form-control btn btn-secondary" v-on:click="moveToCustomerLogin()">업체 로그인
          </button>
        </div>
      </div>

    </div>
    <img src="@/assets/images/login_bg.png" width="100%"/>
    <v-dialog/>
  </div>
</template>
<script>
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';

    export default {
        name: 'Login',
        data() {
            return {
                msg: 'UTASCO 관리자',
                userName: '',
                password: '',
                autoLogin: false,
                isMobile: false,
            }
        },
        created: function () {
            console.log("Mobile: " + isFromMobile());
            this.$data.isMobile = isFromMobile();
            localStorage.removeItem('account_type');
            localStorage.removeItem('customer_printer');
        },
        mounted: function () {
            if (localStorage.getItem('autoLogin')) {
                if (localStorage.getItem('autoLogin') != null &&
                    localStorage.getItem('userName') != null &&
                    localStorage.getItem('password') != null) {
                    this.$data.autoLogin = localStorage.getItem('autoLogin');
                    this.$data.userName = localStorage.getItem('userName');
                    this.$data.password = localStorage.getItem('password');
                    console.log("Now auto login");
                    this.login();
                } else {
                    localStorage.setItem('autoLogin', false);
                }
            }
        },
        methods: {
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            moveToCustomerLogin: function () {
                Router.push('/');
            },
            login: function () {
                if (this.$data.userName.length == 0) {
                    console.log("no user name");
                    this.showModal("ERROR", "Enter User ID");
                    return;
                }
                var password = this.$data.password;

                if (password.length == 0) {
                    this.showModal("ERROR", "Enter Password");
                    return;
                }

                var self = this;
                axios.get(process.env.APP_URL + 'api/admin_login.php?user_name=' + this.$data.userName + '&password=' + password)
                    .then(response => {
                        console.log(response.data);
                        var data = response.data;
                        if (data['success'] == true) {
                            var userItem = data['user'];

                            localStorage.setItem('id', userItem['id']);
                            localStorage.setItem('email', userItem['email']);
                            localStorage.setItem('level', userItem['level']);
                            localStorage.setItem('admin', true);
                            localStorage.setItem('account_type', 'admin');
                            localStorage.removeItem('customer_printer');
                            console.log("auto check in " + $("#autoLogin").is(':checked'));
                            if ($("#autoLogin").is(':checked') == true) {
                                localStorage.setItem('userName', self.$data.userName);
                                localStorage.setItem('autoLogin', true);
                                localStorage.setItem('password', self.$data.password);
                            } else {
                                localStorage.setItem('autoLogin', false);
                                localStorage.setItem('password', '');
                                localStorage.setItem('userName', '');
                            }
                            if (self.$data.isMobile) {
                                Router.push('admin/checkin');
                            } else {
                                Router.push('admin/home');
                            }
                        } else {
                            self.showModal("LOGIN FAIL", data['message']);
                            localStorage.setItem('autoLogin', false);
                            localStorage.setItem('password', '');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        self.showModal("ERROR", error);
                    });


            }
        }

    }
</script>
<style>
  .admin-login-btn {
    background-color: brown;
    color: white;
    border: none;
    font-weight: bold;

  }

  .admin-login-btn:hover {
    background-color: #990000;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminLogin.vue